module.exports = __webpack_public_path__ + "img/大数据验号旺旺照妖镜6.03c6d8cb.gif";